import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import defaultShield from '@sorare/core/src/assets/club/shield_none.png';
import { Shield } from '@sorare/core/src/assets/icons/Shield';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { withFragments } from '@sorare/core/src/lib/gql';

import { RuleHelperFnReturnType } from '../types';
import { getAtLeastOfClubsRule_so5Rules } from './__generated__/getAtLeastOfClubsRule.graphql';

export const getAtLeastOfClubsRule = withFragments(
  (
    rules: getAtLeastOfClubsRule_so5Rules,
    error: string
  ): RuleHelperFnReturnType => {
    const rule = rules.atLeastOfClubs;
    if (!rule) {
      return null;
    }

    return {
      id: 'atLeastOfClubs',
      icon: <Shield size={2} />,
      label: (
        <FormattedMessage
          id="Rules.atLeastOfClubs.label"
          defaultMessage="Min {min, plural, one {# player} other {# players}} from specific clubs"
          values={{ min: rule.min }}
        />
      ),
      description: (
        <Vertical as="span" gap={0}>
          {rule.clubs.map(club => (
            <Horizontal key={club.slug} as="span">
              <img
                src={club.pictureUrl || defaultShield}
                alt=""
                width="16"
                height="16"
              />
              {club.name}
            </Horizontal>
          ))}
        </Vertical>
      ),
      error,
    };
  },
  {
    so5Rules: gql`
      fragment getAtLeastOfClubsRule_so5Rules on So5Rules {
        id
        atLeastOfClubs {
          min
          clubs {
            slug
            name
            pictureUrl
          }
        }
      }
    ` as TypedDocumentNode<getAtLeastOfClubsRule_so5Rules>,
  }
);
